import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
const headListHistory = [
  {
    headTitle: "担当者",
  },
  {
    headTitle: "処理",
  },
  {
    headTitle: "実施日",
  },
  {
    headTitle: "コメント",
  },
];

const headList = [
  {
    headTitle: "請求ID",
  },
  {
    headTitle: "返還請求依頼先",
  },
  {
    headTitle: "区分",
  },
  {
    headTitle: "請求額",
  },
  {
    headTitle: "入金額",
  },
  {
    headTitle: "返還請求依頼額",
  },
];

//上長承認以降※のみ表示
// ※最新申請状態=08,11,13
const listData2: any[] = [
  {
    headTitle: "帳票名",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
  {
    headTitle: "決裁日",
    align: "left",
  },
];

const overPaymentKbn = [
  {
    value: "1",
    label: "過納金（既契約掛金）",
  },
  {
    value: "2",
    label: "過納金（途中掛金）",
  },
];

const overPaymentProcessStatus = [
  {
    value: "1",
    label: "過納法人一覧",
  },
  {
    value: "2",
    label: "返還請求依頼済み法人一覧",
  },
  {
    value: "3",
    label: "口座情報入力済み一覧",
  },
];

const listData: any = [
  {
    keyword: "searchKbn",
    type: "selectFrom",
    label: "区分",
    selectPropsList: overPaymentKbn,
  },
  {
    keyword: "searchContractorName",
    type: "label",
    label: "法人名",
  },
  {
    keyword: "searchBillingKbn",
    type: "selectFrom",
    label: "処理状況",
    selectPropsList: overPaymentProcessStatus,
    wantToSetValue: "1",
  },
];

const schema = {
  searchContractorName: {
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
};
export { headList, listData, schema, headListHistory, listData2 };
